import React from 'react';
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="container-fluid bg-black">
      <footer className="row row-cols-1 row-cols-sm-2 row-cols-md-5 py-3 my-0 border-top">
        <div className="col mb-3">
          {/* Logo */}
          <a
            href="/"
            className="d-flex flex-column align-items-center mb-3 link-body-emphasis text-decoration-none"
          >
            <img
              className="navbar-logo"
              src="./premdigitallogo.png"
              style={{ height: "90px" }}
              alt="Logo"
            />
            <span className="fs-5 text-light" style={{ color: "#F97316" }}>
              Prem Digitals
            </span>
          </a>
          <p className="text-light mb-0 ml-12">
            Transforming spaces with vibrant signboards that communicate your message effortlessly.
          </p>
        </div>

        <div className="col mb-3 mt-5 " >
          {/* Address */}
          <p className="text-light mb-0">      <i className="fas fa-phone" style={{color:'#F97316' }}></i><span> : </span> +91 9700277740</p>
          <p className="whitespace-nowrap text-light">
          <i className="fas fa-envelope" style={{color:'#F97316' }}></i><span> : </span>
             contactus@premdigitalsignage.com
          </p>
          <p className="text-light mb-0">1-112/3/5/A, 1st floor ,Miyapur Rd,</p>
          <p className="text-light mb-0">Hyderabad, Telangana 500049</p>
        </div>

        <div className="col mb-3">
          <h5 style={{ color: '#F97316' }}>Important Links</h5>
          <ul className="nav flex-column">
            <li className="nav-item mb-2 cursor-pointer hover:text-orange-500">
              <Link to="/" className="nav-link p-0 text-light ">
                Home
              </Link>
            </li>
            <li className="nav-item mb-2 cursor-pointer hover:text-orange-500">
              <Link to="/about" className="nav-link p-0 text-light ">
                about
              </Link>
            </li>
            <li className="nav-item mb-2 cursor-pointer hover:text-orange-500">
              <Link to="/services" className="nav-link p-0 text-light ">
               services
              </Link>
            </li>
            <li className="nav-item mb-2 cursor-pointer hover:text-orange-500">
              <Link to="/gallery" className="nav-link p-0 text-light ">
               gallery
              </Link>
            </li>
            <li className="nav-item mb-2 cursor-pointer hover:text-orange-500">
              <Link to="/contact" className="nav-link p-0 text-light ">
               contact
              </Link>
            </li>
          </ul>
        </div>

        <div className="col mb-3">
          <h5 style={{ color: '#F97316' }}>Areas We Serve</h5>
          <ul className="nav flex-column">
            <li className="nav-item mb-2">
              <Link to="#" className="nav-link p-0 text-light">
                Miyapur
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="#" className="nav-link p-0 text-light">
              Lingampalli
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="#" className="nav-link p-0 text-light">
                Madhapur
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="#" className="nav-link p-0 text-light">
                KPHB
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="#" className="nav-link p-0 text-light">
              Gachibowli

              </Link>
            </li>
          </ul>
        </div>

        <div className="col mb-3 mr-0">
          <h5 style={{ color: '#F97316' }}>Our Services</h5>
          <ul className="nav flex-column">
            <li className="nav-item mb-2">
              <Link to="#" className="nav-link p-0 text-light">
                Acrylic Boards
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="#" className="nav-link p-0 text-light">
                Glow Sign Boards
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="#" className="nav-link p-0 text-light">
                Channel Letters
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="#" className="nav-link p-0 text-light">
              CNc cutting Board
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to="#" className="nav-link p-0 text-light">
                Business Cards
              </Link>
            </li>
          </ul>
        </div>
      </footer>

      <footer className="row mt-0">
        <div>
          <p className="text-light row justify-content-center d-flex">© 2025 Copyright : PremDigital | Powered by BOBROS</p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
